// PRD-3334: Google and Microsoft sign-in leave this tab for the provider and come back (product, 2026-10-23:
// full-page like other sites, no popup). What the return needs to check is kept in this tab's sessionStorage.

const KEY = "plgSsoPending";

export type PendingSso =
  | { provider: "google"; state: string; codeVerifier: string }
  | { provider: "microsoft"; nonce: string };

/** What a Google / Microsoft return hands to the sign-in page (kept out of the URL). */
export type SsoResult =
  | { provider: "google"; code: string; codeVerifier: string }
  | { provider: "microsoft"; idToken: string; nonce: string };

export function savePendingSso(pending: PendingSso): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(pending));
  } catch {
    // storage blocked: the return is ignored and the visitor clicks again
  }
}

/** The pending sign-in, removed as it is read so a return is used once. */
export function takePendingSso(): PendingSso | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return raw ? (JSON.parse(raw) as PendingSso) : null;
  } catch {
    return null;
  }
}

/** Without removing it: is a sign-in with this provider waiting for its return? */
export function hasPendingSso(provider: PendingSso["provider"]): boolean {
  try {
    const raw = sessionStorage.getItem(KEY);
    return !!raw && (JSON.parse(raw) as PendingSso).provider === provider;
  } catch {
    return false;
  }
}
